<template>
<v-card>
  <v-card-title class='title' >
    <v-icon class='mr-1' >insert_chart</v-icon>
    Reports have moved
  </v-card-title>
  <blockquote class='blockquote' >
    Check out our new reports with
    <a href="https://dashboard.appointmentguru.co" target="_blank" >
      AppointmentGuru Numbers
      <v-icon small class='ml-2' >open_in_new</v-icon>
    </a>
  </blockquote>
  <v-card-actions >
    <v-spacer />
    <v-btn large href="https://dashboard.appointmentguru.co" target="_blank" color='primary' >
      Open the Dashboard
      <v-icon class='ml-2' >open_in_new</v-icon>
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'ReportsPage'
}
</script>



// WEBPACK FOOTER //
// Reports.vue?7a45fbb9